import { __assign } from 'tslib';

var _a, _b, _c, _d;
var tag = {
    base: {
        appearance: "none",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        lineHeight: 4,
        height: "var(--tag-height)",
        width: "fit-content",
        borderRadius: "calc(var(--tag-height)/2)",
        color: "black.100",
        backgroundColor: "var(--tag-color-bg)",
        fontFamily: "body",
        fontSize: "var(--font-size)",
        whiteSpace: "nowrap",
        border: "1px solid transparent",
        maxWidth: "100%",
        "--colors-shadow": "var(--colors-black-shadow)",
    },
    variants: {
        tone: {
            primary: {
                "--tag-color-border": "var(--colors-primary-100)",
                "--tag-color-bg": "var(--colors-primary-10)",
            },
            secondary: {
                "--tag-color-border": "var(--colors-black-100)",
                "--tag-color-bg": "var(--colors-black-5)",
            },
            success: {
                "--tag-color-border": "var(--colors-success-60)",
                "--tag-color-bg": "var(--colors-success-10)",
            },
            warning: {
                "--tag-color-border": "var(--colors-warning-60)",
                "--tag-color-bg": "var(--colors-warning-10)",
            },
            critical: {
                "--tag-color-border": "var(--colors-critical-60)",
                "--tag-color-bg": "var(--colors-critical-10)",
            },
        },
        disabled: {
            true: {
                cursor: "not-allowed",
                opacity: 0.6,
            },
        },
        size: {
            sm: {
                "--tag-height": "24px",
                "--font-size": "12px",
                pl: 2,
                pr: 2,
            },
            md: {
                "--tag-height": "27px",
                "--font-size": "14px",
                pl: 3,
                pr: 3,
            },
            lg: {
                "--tag-height": "33px",
                "--font-size": "18px",
                pl: 4,
                pr: 4,
            },
        },
    },
    defaultProps: {
        look: "",
        size: "md",
        tone: "primary",
        disabled: false,
    },
};
var tagIcons = {
    base: {
        fontSize: "inherit",
    },
    variants: {
        position: {
            left: {
                ml: "calc(var(--icon-margin)*-1)",
                mr: "calc(var(--icon-margin)*2)",
            },
            right: {
                mr: "calc(var(--icon-margin)*-1)",
                ml: "calc(var(--icon-margin)*2)",
            },
        },
        look: {
            default: {
                "--icon-size-lg": "16px",
                "--icon-size-md": "14px",
                "--icon-size-sm": "12px",
            },
            action: {
                "--icon-size-lg": "18px",
                "--icon-size-md": "16px",
                "--icon-size-sm": "14px",
            },
        },
        tone: {
            primary: {
                color: "primary.100",
            },
            secondary: {
                color: "secondary.60",
            },
            success: {
                color: "success.60",
            },
            warning: {
                color: "warning.60",
            },
            critical: {
                color: "critical.60",
            },
        },
        size: {
            lg: {
                "--icon-size": "var(--icon-size-lg)",
                "--icon-margin": "3px",
                fontSize: "var(--icon-size)",
            },
            md: {
                "--icon-size": "var(--icon-size-md)",
                "--icon-margin": "2px",
                fontSize: "var(--icon-size)",
            },
            sm: {
                "--icon-size": "var(--icon-size-sm)",
                "--icon-margin": "2px",
                fontSize: "var(--icon-size)",
            },
        },
    },
};
var tagIconButton = {
    base: {
        appearance: "none",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        fontSize: "inherit",
        color: "black.60",
        "--colors-shadow": "var(--colors-black-shadow)",
        height: "auto",
        width: "auto",
        background: "none",
        border: "none",
        borderRadius: "100%",
        p: 0,
        cursor: "pointer",
        ":hover:not(:disabled)": {
            boxShadow: 1,
            color: "black.100",
        },
        ":focus": {
            boxShadow: 0,
            ":hover": {
                boxShadow: 0,
            },
            outline: "none",
        },
    },
    variants: {
        size: {
            lg: {
                fontSize: "18px",
            },
            md: {
                fontSize: "16px",
            },
            sm: {
                fontSize: "14px",
            },
        },
        tone: {
            primary: {
                color: "primary.100",
            },
            secondary: {
                color: "black.60",
            },
            success: {
                color: "success.60",
            },
            warning: {
                color: "warning.60",
            },
            critical: {
                color: "critical.60",
            },
        },
        disabled: {
            true: {
                cursor: "not-allowed",
                opacity: 1,
            },
        },
    },
};
var tagButton = {
    base: __assign(__assign({}, tag.base), { "& .TagIcon.look-action": {
            color: "black.60",
        }, ":focus": {
            borderColor: "var(--tag-color-border)",
            outline: "none",
        }, ":hover:not(:disabled)": {
            cursor: "pointer",
            boxShadow: 1,
            "& .TagIcon.look-action": {
                color: "black.100",
            },
        } }),
    variants: {
        look: __assign({}, (_a = tag.variants) === null || _a === void 0 ? void 0 : _a.look),
        tone: __assign({}, (_b = tag.variants) === null || _b === void 0 ? void 0 : _b.tone),
        disabled: __assign({}, (_c = tag.variants) === null || _c === void 0 ? void 0 : _c.disabled),
        size: __assign({}, (_d = tag.variants) === null || _d === void 0 ? void 0 : _d.size),
    },
};

export { tag, tagButton, tagIconButton, tagIcons };
//# sourceMappingURL=tag.js.map
